<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">客户界面分类</div>
      </div>
      <div class="flex-1 h-0" v-if="menuList">
        <cate-menu :menu-data="menuList" :not-operate="true" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0">
      <div style="padding: 10px 20px 20px 0" class="flex-column h-100">
        <div class="flex content-top mb-10">
          <div class="flex-1 bg-ff h-100 flex align-center pl-10 ptb-5">
            <div class="flex align-center mr-20 cursor">
              <div class="mr-5 decoration-line" ></div>
              <div class="font-bold font-16-46b8b0" >详情字段</div>
            </div>
          </div>
        </div>
        <div class="bg-ff font-12-ff5555 text-left align-center ptb-8 border-b-e2 pl-20 flex align-center">
          <div>
            <i class="el-icon-warning mr-5"></i>
            提示：请点击选择详情字段，可多选。
          </div>
          <div class="mlr-40" style="width: 200px" @change="allSelect">
            <el-checkbox v-model="allChecked" label="全选"></el-checkbox>
          </div>
        </div>
        <div class="flex-1" style="border-radius: 10px">
          <div class="h-100 flex-column bg-ff">
            <div class="flex-1 h-0">
              <div class="h-100 plr-10">
                <el-scrollbar class="h-100 hide-x">
                  <div class="flex align-center flex-wrap ptb-10">
                    <div v-for="item in dataList" :key="item.id" @change="changeSelect(item)" class="flex align-center mb-10" style="width: 200px">
                      <el-checkbox v-model="item.isChecked" :label="item.name"></el-checkbox>
                      <!--<div :class="item.isChecked ? 'font-12-46b8b0' : 'font-12-30313a'" class="text-left ml-5">-->
                      <!--{{item.name}}-->
                      <!--</div>-->
                    </div>
                  </div>
                </el-scrollbar>
              </div>
            </div>
            <div style="height: 50px; border-top: 1px solid #e2e2e2" class="flex align-center justify-center">
              <div class="btn-30-border-85 mr-10" @click="getData">重置</div>
              <div class="btn-30-bg-46b8b0-s" @click="onSave">保存</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CateMenu from '../../components/CateMenu'
import MoveHorizon from '../../components/MoveHorizon'
export default {
  name: 'customerViewDefine',
  components: {CateMenu, MoveHorizon},
  data () {
    return {
      chooseMenuId: 'addCustomer',
      currentMenu: {
        name: '储备客户',
        id: 'addCustomer'
      },
      menuList: [
        {
          name: '储备客户',
          id: 'addCustomer'
        }, {
          name: '咨询预报客户',
          id: 'submitDoorForecast'
        }, {
          name: '咨询客户',
          id: 'submitDoorCustomer'
        }, {
          name: '订金客户',
          id: 'submitIntentionCustomer'
        }, {
          name: '设计合同',
          id: 'submitDesignContractCustomer'
        }, {
          name: '预算审核',
          id: 'submitBudgetExamine'
        }, {
          name: '施工合同',
          id: 'submitConstructionContract'
        }, {
          name: '施工客户',
          id: 'submitProjectManager'
        }, {
          name: '售后服务',
          id: 'submitAs '
        }, {
          name: '飞单客户',
          id: 'submitFail '
        }, {
          name: '全部客户',
          id: 'all '
        }
      ],
      dataList: [],
      allChecked: false
    }
  },
  created () {
    this.getData()
  },
  mounted () {},
  methods: {
    allSelect () {
      for (let i = 0; i < this.dataList.length; i++) {
        this.dataList[i].isChecked = this.allChecked
      }
    },
    changeSelect (item) {
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id === item.id) {
          this.dataList[i].isChecked = item.isChecked
        }
      }
    },
    onSave () {
      let checkedList = []
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].isChecked) {
          checkedList.push({
            companyId: this.$store.state.companyId,
            processKey: this.chooseMenuId,
            field: this.dataList[i].field,
            name: this.dataList[i].name
          })
        }
      }
      let arr = []
      arr = checkedList
      for (let j = 0; j < checkedList.length; j++) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].field === checkedList[j].field && i !== j) {
            checkedList.splice(j, 1)
          }
        }
      }
      if (checkedList.length > 0) {
        this.axios.post('customerInterface/save', checkedList).then(res => {
          if (res.data.success) {
            this.$message.success('设置成功！')
            checkedList = []
            arr = []
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      } else {
        this.$message({
          message: '请选择要设置的字段',
          type: 'warning',
          offset: 400
        })
      }
    },
    getData () {
      this.axios.post('customerInterface/list', {companyId: this.$store.state.companyId, processKey: this.chooseMenuId}).then(res => {
        if (res.data.success) {
          this.dataList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu) {
      if (menu.id !== this.chooseMenuId) {
        this.chooseMenuId = menu.id
        this.currentMenu = menu
        this.getData()
        this.allChecked = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/customerViewDefine.vue